import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::index
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:26
* @route '/studio/{team}/scenarios/{scenario}/versions'
*/
export const index = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/scenarios/{scenario}/versions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::index
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:26
* @route '/studio/{team}/scenarios/{scenario}/versions'
*/
index.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
    }

    return index.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::index
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:26
* @route '/studio/{team}/scenarios/{scenario}/versions'
*/
index.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::index
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:26
* @route '/studio/{team}/scenarios/{scenario}/versions'
*/
index.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::index
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:26
* @route '/studio/{team}/scenarios/{scenario}/versions'
*/
const indexForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::index
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:26
* @route '/studio/{team}/scenarios/{scenario}/versions'
*/
indexForm.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::index
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:26
* @route '/studio/{team}/scenarios/{scenario}/versions'
*/
indexForm.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::edit
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:51
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
export const edit = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/scenarios/{scenario}/versions/{version}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::edit
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:51
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
edit.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            version: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        version: typeof args.version === 'object'
        ? args.version.id
        : args.version,
    }

    return edit.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{version}', parsedArgs.version.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::edit
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:51
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
edit.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::edit
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:51
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
edit.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::edit
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:51
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
const editForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::edit
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:51
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
editForm.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::edit
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:51
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
editForm.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::update
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:70
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
export const update = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/studio/{team}/scenarios/{scenario}/versions/{version}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::update
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:70
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
update.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            version: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        version: typeof args.version === 'object'
        ? args.version.id
        : args.version,
    }

    return update.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{version}', parsedArgs.version.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::update
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:70
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
update.patch = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::update
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:70
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
const updateForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::update
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:70
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
updateForm.patch = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::destroy
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:101
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
export const destroy = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/studio/{team}/scenarios/{scenario}/versions/{version}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::destroy
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:101
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
destroy.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
            version: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
        version: typeof args.version === 'object'
        ? args.version.id
        : args.version,
    }

    return destroy.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace('{version}', parsedArgs.version.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::destroy
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:101
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
destroy.delete = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::destroy
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:101
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
const destroyForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\ScenarioVersionController::destroy
* @see Http/Controllers/Web/Studio/ScenarioVersionController.php:101
* @route '/studio/{team}/scenarios/{scenario}/versions/{version}'
*/
destroyForm.delete = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number }, version: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const versions = {
    index: Object.assign(index, index),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default versions